import { ExternalLinkIcon } from 'foundations-assets/icons/components/ExternalLinkIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { useCallback, useState } from 'react';
import { CrmRecordChipCardContent } from './CrmRecordChipCardContent';
import { CrmRecordChipHeader } from './CrmRecordChipHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CrmRecordChipCard = ({
  title,
  icon,
  properties,
  onClick
}) => {
  const isClickable = !!onClick;
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = useCallback(() => {
    setIsHovered(true);
  }, []);
  const handleMouseLeave = useCallback(() => {
    setIsHovered(false);
  }, []);
  const handleClick = useCallback(e => {
    e.stopPropagation();
    onClick === null || onClick === void 0 || onClick();
  }, [onClick]);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "300",
    paddingBlockEnd: "400",
    overflowY: "auto",
    paddingBlockStart: "200",
    paddingInline: "200",
    children: [/*#__PURE__*/_jsx(Flex, {
      flexDirection: "row",
      alignItems: "center",
      gap: "200",
      paddingBlock: "300",
      paddingInlineStart: "300",
      paddingInlineEnd: "500",
      backgroundColor: isClickable && isHovered ? 'fill-tertiary-hover' : 'fill-surface-recessed',
      borderRadius: "300",
      onMouseEnter: isClickable ? handleMouseEnter : undefined,
      onMouseLeave: isClickable ? handleMouseLeave : undefined,
      children: isClickable ? /*#__PURE__*/_jsx(Button, {
        use: "unstyled",
        onClick: handleClick,
        block: true,
        width: "100%",
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          alignItems: "center",
          gap: "200",
          children: [/*#__PURE__*/_jsx(Flex, {
            flexGrow: 1,
            minInlineSize: "0",
            children: /*#__PURE__*/_jsx(CrmRecordChipHeader, {
              title: title,
              icon: icon,
              textDecoration: isHovered ? 'underline' : 'none'
            })
          }), isHovered && /*#__PURE__*/_jsx(Flex, {
            flexShrink: 0,
            alignItems: "center",
            children: /*#__PURE__*/_jsx(ExternalLinkIcon, {
              size: "300"
            })
          })]
        })
      }) : /*#__PURE__*/_jsx(CrmRecordChipHeader, {
        title: title,
        icon: icon
      })
    }), /*#__PURE__*/_jsx(CrmRecordChipCardContent, {
      properties: properties
    })]
  });
};